import {Form, formsStore} from '../../../../stores/Form';
import {priority} from '@priority-software/priority-proto-api/lib';
import {FormDesignData} from '../../../../stores/Form/Form';

type Props = {
    formName: string;
    startSubFormRes: priority.netitems.form.IStartRs;
    columnsRs: priority.netitems.form.IColumnsRs;
    subFormLevel: number;
    formCustomData: {[key: string]: any};
    designData: FormDesignData;
};

export const createSubFormInstance = (session: string, payload: Props) => {
    const {formName, startSubFormRes, columnsRs, subFormLevel, formCustomData, designData} =
        payload;
    const screen = formsStore.getScreenBySession(session);
    const form = screen?.form;
    const activeSubForm = form?.activeSubForm;

    if (
        activeSubForm &&
        activeSubForm.ename === formName &&
        activeSubForm.level === payload.subFormLevel
    ) {
        return activeSubForm;
    }

    return new Form(
        formName,
        startSubFormRes,
        columnsRs,
        subFormLevel,
        formCustomData,
        designData,
        form?.currentRecord?.getRecordCompany()?.toString()
    );
};
